import { SelectOption } from "../common/components/form/Select";
import { NodeRole } from "../types/node";
import { UserRole } from "../types/userCurrent";

export const isUserPO = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.PO);
export const isUserContractor = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.Contractor);
export const isUserArchitect = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.Architect);
// export const isUserFinance = (currentRoles: UserRole[]): boolean =>
//     currentRoles.includes(UserRole.FinanceOfficer);
export const isUserDirector = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.Director);
export const isUserPaymentApprover = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.PaymentOrderApprover);
export const isUserAdmin = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.Admin);
export const isUserSuperAdmin = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.SuperAdmin);
export const isUserClaimApprover = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.ClaimApprover);
export const isUserFinanceDepartment = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.FinanceDepartment);
export const isUserHSBCOperator = (currentRoles: UserRole[]): boolean =>
    currentRoles.includes(UserRole.HSBCOperator);

export const isNodeDeveloper = (): boolean =>
    process.env.REACT_APP_PARTY === NodeRole.DEVELOPER;
export const isNodeMainContractor = (): boolean =>
    process.env.REACT_APP_PARTY === NodeRole.CONTRACTOR;

export const parseRoleToText = (role: UserRole | string): string => {
    switch (UserRoleStripPrefix(role)) {
        case UserRoleStripPrefix(UserRole.Admin):
            return "Admin";
        case UserRoleStripPrefix(UserRole.SuperAdmin):
            return "Super Admin";
        case UserRoleStripPrefix(UserRole.PO):
            return "Project Officer";
        case UserRoleStripPrefix(UserRole.Contractor):
            return "Service Provider";
        case UserRoleStripPrefix(UserRole.Director):
            return "Director";
        case UserRoleStripPrefix(UserRole.Architect):
            return "Architect";
        case UserRoleStripPrefix(UserRole.HSBCOperator):
            return "HSBC Operator";
        case UserRoleStripPrefix(UserRole.FinanceDepartment):
            return "Finance Department";
        case UserRoleStripPrefix(UserRole.ClaimApprover):
            return "Claim Approver";
        case UserRoleStripPrefix(UserRole.PaymentOrderApprover):
            return "Payment Order Approver";
        default:
            return "";
    }
};

export const UserRoleStripPrefix = (role: UserRole | string): string => {
    return role.replace("ROLE_", "");
};

const toUserRoleOptions = (list: UserRole[]) =>
    list.map((value) => ({
        value: UserRoleStripPrefix(value),
        label: parseRoleToText(value),
    }));

export const getUserRoleOptionsByProfileType = (
    profileType: string,
    currentRoles: UserRole[]
): SelectOption[] => {
    const developerNodeUserRoles: Record<string, UserRole[]> = {
        APPROVER: [UserRole.ClaimApprover, UserRole.PaymentOrderApprover],
        DEVELOPER: [UserRole.Admin, UserRole.FinanceDepartment, UserRole.PO],
        HSBC: [UserRole.HSBCOperator, UserRole.SuperAdmin],
    };

    const developerNodeAdminUserRoles: Record<string, UserRole[]> = {
        APPROVER: [UserRole.ClaimApprover, UserRole.PaymentOrderApprover],
        DEVELOPER: [UserRole.Admin, UserRole.FinanceDepartment, UserRole.PO],
    };

    const contractorNodeUserRoles: Record<string, UserRole[]> = {
        HSBC: [UserRole.SuperAdmin],
        MAIN_CONTRACTOR: [UserRole.Contractor, UserRole.Admin],
    };

    const contractorNodeAdminUserRoles: Record<string, UserRole[]> = {
        MAIN_CONTRACTOR: [UserRole.Contractor],
    };
    switch (true) {
        case profileType && isNodeDeveloper() && isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(developerNodeUserRoles[profileType] ?? []);
        case profileType && isNodeDeveloper() && !isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(developerNodeAdminUserRoles[profileType] ?? []);
        case profileType && isNodeMainContractor() && isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(
                contractorNodeUserRoles[profileType] ?? [],
            );
        case profileType && isNodeMainContractor() && !isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(
                contractorNodeAdminUserRoles[profileType] ?? [],
            );
        case !profileType && isNodeDeveloper() && isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(
                Object.values(developerNodeUserRoles).flat(),
            );
        case !profileType && isNodeDeveloper() && !isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(
                Object.values(developerNodeAdminUserRoles).flat(),
            );
        case !profileType && isNodeMainContractor() && isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(
                Object.values(contractorNodeUserRoles).flat(),
            );
        case !profileType && isNodeMainContractor() && !isUserSuperAdmin(currentRoles):
            return toUserRoleOptions(
                Object.values(contractorNodeAdminUserRoles).flat(),
            );
        default:
            return [];
    }
};
